import { type GetServerSidePropsContext } from 'next';

import { categoryService } from '../../../services/category';
import { withEnhancedPageHandler } from '../../../middlewares/withEnhancedPageHandler';

import { ProspectTemplateCategory } from '../../../templates';
import { staticContent } from '../../../data/seja-um-profissional';
import { applyCorrelationIdHeader } from '../../../utils/server/applyCorrelationIdHeader';

export default function SejaUmProfissional(props) {
  return <ProspectTemplateCategory {...props} />;
}

async function getServerSidePropsHandler({
  params,
  req,
  res,
  query,
}: GetServerSidePropsContext) {
  const { refresh } = query;
  const { category, service } = params;
  const customHeaders = applyCorrelationIdHeader(req.headers);

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const dynamicData = await categoryService({
    categorySlug: `${category}/${[].concat(service).join('/')}`,
    refresh: refresh && refresh === 'true',
    customHeaders,
  });

  const pageContentExists = dynamicData.eligibleForAnunciePage;

  if (!pageContentExists) {
    return {
      redirect: {
        destination: '/seja-um-profissional',
        permanent: false,
      },
    };
  }

  return { props: { dynamicData, staticContent } };
}

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);
